import { AnswerApiModel } from '../../Services/api/v2/Models/AnswerApiModel';

export class DynamicFormAnswer implements AnswerApiModel {
	Id: number | null;
	QuestionId: number;
	StringValue: string | null;
	IntValue: number | null;
	BoolValue: boolean | null;
	Choices: Array<number>;

	Valid: () => boolean;

	constructor(answer: AnswerApiModel | null, questionId: number, validFunc: () => boolean) {
		if (answer !== null) {
			this.StringValue = answer.StringValue;
			this.IntValue = answer.IntValue;
			this.BoolValue = answer.BoolValue;
			this.Choices = answer.Choices;
		} else {
			this.StringValue = null;
			this.IntValue = null;
			this.BoolValue = null;
			this.Choices = [];
		}

		this.QuestionId = questionId;

		this.Valid = validFunc;
	}
}
